import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, Fragment as _Fragment, unref as _unref, createBlock as _createBlock, renderList as _renderList, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-42c0db22"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flex-grow-1 min-w-0" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-subtitle-1 font-weight-bold" }, "Mi inscripción", -1))
const _hoisted_3 = {
  key: 0,
  class: "text-body-2 text-medium-emphasis nombre"
}
const _hoisted_4 = {
  key: 0,
  class: "d-flex justify-center py-8"
}
const _hoisted_5 = { class: "text-body-2 font-weight-bold nombre" }
const _hoisted_6 = { class: "text-body-2 mb-1" }
const _hoisted_7 = { class: "text-medium-emphasis" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "text-subtitle-2 font-weight-bold mt-3 mb-2" }, "Lista de la pareja", -1))
const _hoisted_9 = { class: "text-body-2" }
const _hoisted_10 = {
  key: 0,
  class: "text-medium-emphasis"
}
const _hoisted_11 = {
  key: 0,
  class: "d-flex ga-1 mt-3"
}
const _hoisted_12 = {
  key: 0,
  class: "mt-3"
}
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "text-subtitle-2 font-weight-bold mt-3 mb-2" }, "Miembros", -1))
const _hoisted_14 = { class: "text-body-2 font-weight-bold" }
const _hoisted_15 = {
  key: 0,
  class: "text-medium-emphasis font-weight-regular"
}
const _hoisted_16 = {
  key: 0,
  class: "text-body-2"
}
const _hoisted_17 = {
  key: 0,
  class: "text-medium-emphasis"
}
const _hoisted_18 = {
  key: 1,
  class: "d-flex ga-1 mt-3"
}
const _hoisted_19 = {
  key: 0,
  class: "mt-3"
}
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-body-2 text-warning" }, "Hueco libre", -1))
const _hoisted_21 = {
  key: 0,
  class: "d-flex mt-3"
}
const _hoisted_22 = {
  key: 2,
  class: "text-center mt-4"
}

import { computed, onMounted, ref } from "vue";
import { ComponentesEquipoDTO, InscripcionEquipoDTO } from "@/interfaces/Inscripcion";
import {
  eliminarMiembroEquipoAsync,
  getInscripcionEquipo,
} from "@/services/InscripcionesService";
import { useAuth } from "@/composables/useAuth";
import { useToast } from "@/composables/useToast";
import { convertirFecha, diaDeHoy, ultimoDiaEvento } from "@/utils/Fecha";
import { estadoLista } from "@/utils/estadoLista";
import {
  CrearListaTorneoRequestDTO,
  ModificarListaTorneoRequestDTO,
  RequesListaDTO,
} from "@/interfaces/Lista";
import { subirListaTorneo, modificarListaTorneo } from "@/services/ListasService";
import { UsuarioSinEquipoDTO } from "@/interfaces/Usuario";
import { getUsuariosNoInscritosTorneoAsync } from "@/services/UsuariosService";
import { getTorneo } from "@/services/TorneosService";
import { Torneo } from "@/interfaces/Torneo";
import ModalEnviarLista from "./ModalEnviarLista.vue";
import InterruptorCompartirEmail from "./InterruptorCompartirEmail.vue";
import ModalAddMiembroEquipo from "../GestionTorneos/Equipos/ModalAddMiembroEquipo.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'ModalInscripcionEquipo',
  props: {
    idInscripcion: {},
    idUsuario: {},
    idTorneo: {},
    idOrganizador: {}
  },
  emits: ["close", "eliminar-inscripcion-equipo", "actualizada"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const { getidUsuario } = useAuth();
const { triggerToast } = useToast();
const idUsuarioLogger = Number(getidUsuario.value);

const show = ref(true);
const cargando = ref(true);
const detalleTorneo = ref<Torneo>();
const inscripcionData = ref<InscripcionEquipoDTO>({
  idTorneo: 0,
  idCapitan: 0,
  nombreEquipo: "",
  miembros: [],
  idInscripcion: 0,
  idUsuario: 0,
  idEquipo: 0,
  idOrganizador: 0,
  emailOrganizador: "",
  componentesEquipoDTO: [],
});

const esParejas = computed(() => detalleTorneo.value?.tipoTorneo === "Parejas");
const esListaConjunta = computed(
  () => esParejas.value && detalleTorneo.value?.listaPorPareja === true
);
const esCapitan = computed(() => inscripcionData.value.idCapitan === idUsuarioLogger);
const pagado = computed(() => (inscripcionData.value.esPago ?? "").toUpperCase() === "SI");
const nickCapitan = computed(
  () =>
    inscripcionData.value.componentesEquipoDTO.find(c => c.idUsuario === inscripcionData.value.idCapitan)
      ?.nick ?? "Desconocido"
);
const fechaInscripcion = computed(() =>
  inscripcionData.value.fechaInscripcion ? convertirFecha(inscripcionData.value.fechaInscripcion) : ""
);
// Hasta su último día, incluido, se pueden enviar listas, tocar el equipo y darse de baja
const abierta = computed(
  () =>
    !!detalleTorneo.value &&
    ultimoDiaEvento(detalleTorneo.value.fechaInicioTorneo, detalleTorneo.value.fechaFinTorneo) >= diaDeHoy()
);
const puedeCambiarListas = computed(() => esCapitan.value && abierta.value);

// Los miembros y, si faltan, huecos hasta completar el equipo
const MIEMBROS_POR_TIPO: Record<string, number> = {
  Individual: 1,
  Parejas: 2,
  Equipos_2: 2,
  Equipos_4: 4,
  Equipos_6: 6,
};
const equipoConHuecos = computed(() => {
  const miembros = inscripcionData.value.componentesEquipoDTO ?? [];
  const total = MIEMBROS_POR_TIPO[detalleTorneo.value?.tipoTorneo ?? "Individual"] ?? 1;
  return [...miembros, ...Array(Math.max(0, total - miembros.length)).fill(null)] as (ComponentesEquipoDTO | null)[];
});
// La lista conjunta está en la inscripción del capitán; si se subió antes en la del compañero, se usa esa
const listaPareja = computed(() => {
  const miembros = inscripcionData.value.componentesEquipoDTO ?? [];
  return (
    miembros.find(m => m.listaData) ??
    miembros.find(m => m.idUsuario === inscripcionData.value.idCapitan) ??
    null
  );
});

// Al capitán no se le quita: dejaría el equipo sin nadie al mando
const puedeQuitar = (miembro: ComponentesEquipoDTO) =>
  esCapitan.value && abierta.value && miembro.idUsuario !== inscripcionData.value.idCapitan;
const accionesDe = (miembro: ComponentesEquipoDTO) =>
  [
    !esListaConjunta.value && !!miembro.listaData,
    !esListaConjunta.value && puedeCambiarListas.value,
    puedeQuitar(miembro),
  ].filter(Boolean);

// Ver una lista dentro de su tarjeta
const listaVisible = ref<number | null>(null);
const alternarLista = (idInscripcion: number) => {
  listaVisible.value = listaVisible.value === idInscripcion ? null : idInscripcion;
};

// Enviar o cambiar la lista de un miembro
const currentInscripcionId = ref<number>();
const currentUsuarioId = ref<number>();
const currentNick = ref<string>();
const hasLista = ref(false);
const showEnviarCambiarListaModal = ref(false);
const enviarCambiarLista = (miembro: ComponentesEquipoDTO) => {
  currentInscripcionId.value = miembro.idInscripcion;
  currentUsuarioId.value = miembro.idUsuario;
  currentNick.value = miembro.nick;
  hasLista.value = !!miembro.listaData;
  showEnviarCambiarListaModal.value = true;
};

const guardarLista = async (newLista: RequesListaDTO) => {
  const indice = inscripcionData.value.componentesEquipoDTO.findIndex(
    m => m.idInscripcion === currentInscripcionId.value
  );
  if (indice === -1) {
    triggerToast("error", "No se ha podido enviar la lista");
    return;
  }
  const miembro = inscripcionData.value.componentesEquipoDTO[indice];
  try {
    let idLista = miembro.idLista;
    if (miembro.idLista) {
      const request: ModificarListaTorneoRequestDTO = {
        idInscripcion: miembro.idInscripcion,
        idLista: miembro.idLista,
        listaData: newLista.listaData,
        ejercito: newLista.ejercito,
        idUsuario: newLista.idUsuario,
        idTorneo: inscripcionData.value.idTorneo,
      };
      await modificarListaTorneo(request);
    } else {
      const request: CrearListaTorneoRequestDTO = {
        idInscripcion: miembro.idInscripcion,
        listaData: newLista.listaData,
        ejercito: newLista.ejercito,
        idUsuario: newLista.idUsuario,
        idTorneo: inscripcionData.value.idTorneo,
        emailOrganizador: inscripcionData.value.emailOrganizador,
        nick: newLista.nick,
        nombreEquipo: inscripcionData.value.nombreEquipo,
      };
      const response = await subirListaTorneo(request);
      idLista = response.data?.idLista;
    }
    inscripcionData.value.componentesEquipoDTO[indice] = {
      ...miembro,
      estadoLista: "ENTREGADA",
      listaData: newLista.listaData,
      ejercito: newLista.ejercito.name,
      idLista,
    };
    triggerToast("success", miembro.idLista ? "Lista cambiada" : "Lista enviada");
    emit("actualizada");
  } catch (error) {
    console.error("Error al guardar la lista:", error);
    triggerToast("error", "No se ha podido enviar la lista");
  } finally {
    showEnviarCambiarListaModal.value = false;
  }
};

// Quitar a un miembro, tras confirmarlo
const quitar = ref<ComponentesEquipoDTO | null>(null);
const quitando = ref(false);
const confirmarQuitar = async () => {
  if (!quitar.value) return;
  quitando.value = true;
  try {
    await eliminarMiembroEquipoAsync(quitar.value.idInscripcion);
    const idInscripcion = quitar.value.idInscripcion;
    inscripcionData.value.componentesEquipoDTO = inscripcionData.value.componentesEquipoDTO.filter(
      m => m.idInscripcion !== idInscripcion
    );
    triggerToast("success", `${quitar.value.nick} ya no está ${esParejas.value ? "en la pareja" : "en el equipo"}`);
    quitar.value = null;
    emit("actualizada");
  } catch (error) {
    console.error("Error al quitar a un miembro:", error);
    triggerToast("error", "No se ha podido quitar al jugador");
  } finally {
    quitando.value = false;
  }
};

// Añadir a alguien a un hueco libre
const jugadoresSinEquipo = ref<UsuarioSinEquipoDTO[]>([]);
const showModalRegistrarMiembroEquipo = ref(false);
const abrirAnadirMiembro = async () => {
  try {
    const response = await getUsuariosNoInscritosTorneoAsync(inscripcionData.value.idTorneo);
    jugadoresSinEquipo.value = (response?.data ?? []).sort((a: { nick: string }, b: { nick: string }) =>
      a.nick.localeCompare(b.nick)
    );
    showModalRegistrarMiembroEquipo.value = true;
  } catch (error) {
    console.error(error);
    triggerToast("error", "No se han podido cargar los jugadores");
  }
};
const alAnadirMiembro = (nuevoMiembro: ComponentesEquipoDTO) => {
  if (nuevoMiembro && !inscripcionData.value.componentesEquipoDTO.some(m => m.idUsuario === nuevoMiembro.idUsuario)) {
    inscripcionData.value.componentesEquipoDTO.push(nuevoMiembro);
    emit("actualizada");
  }
};

const eliminarInscripcion = (idEquipo: number) => {
  emit("eliminar-inscripcion-equipo", idEquipo);
  show.value = false;
  emit("close");
};
const close = () => {
  show.value = false;
  emit("close");
};
// Cerrarlo pulsando fuera también avisa
const alCambiarVisible = (visible: boolean) => {
  if (!visible) emit("close");
};

onMounted(async () => {
  try {
    const response = await getInscripcionEquipo(props.idInscripcion!);
    inscripcionData.value = response.data;
    if (inscripcionData.value.idTorneo) {
      const respuestaTorneo = await getTorneo(inscripcionData.value.idTorneo);
      detalleTorneo.value = respuestaTorneo.data;
    }
  } catch (error) {
    console.error("Error al obtener datos de la inscripcion:", error);
    triggerToast("error", "No se ha podido cargar la inscripción");
  } finally {
    cargando.value = false;
  }
});

return (_ctx: any,_cache: any) => {
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_progress_circular = _resolveComponent("v-progress-circular")!
  const _component_v_img = _resolveComponent("v-img")!
  const _component_v_expand_transition = _resolveComponent("v-expand-transition")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_dialog = _resolveComponent("v-dialog")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_v_dialog, {
      modelValue: show.value,
      "onUpdate:modelValue": [
        _cache[3] || (_cache[3] = ($event: any) => ((show).value = $event)),
        alCambiarVisible
      ],
      "max-width": "560",
      scrollable: ""
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_card, null, {
          default: _withCtx(() => [
            _createVNode(_component_v_card_title, { class: "d-flex align-start ga-2 text-wrap pt-3" }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_1, [
                  _hoisted_2,
                  (detalleTorneo.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(detalleTorneo.value.nombreTorneo), 1))
                    : _createCommentVNode("", true)
                ]),
                _createVNode(_component_v_btn, {
                  icon: "mdi-close",
                  variant: "text",
                  density: "comfortable",
                  "aria-label": "Cerrar",
                  onClick: close
                })
              ]),
              _: 1
            }),
            _createVNode(_component_v_divider),
            _createVNode(_component_v_card_text, { class: "text-left" }, {
              default: _withCtx(() => [
                (cargando.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                      _createVNode(_component_v_progress_circular, {
                        indeterminate: "",
                        color: "primary"
                      })
                    ]))
                  : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      _createElementVNode("div", _hoisted_5, _toDisplayString(inscripcionData.value.nombreEquipo), 1),
                      _createElementVNode("div", _hoisted_6, [
                        _createElementVNode("span", {
                          class: _normalizeClass(pagado.value ? 'text-success' : 'text-warning')
                        }, _toDisplayString(pagado.value ? "Pagado" : "No pagado"), 3),
                        _createElementVNode("span", _hoisted_7, [
                          _createTextVNode(" · Capitán: " + _toDisplayString(nickCapitan.value) + " ", 1),
                          (fechaInscripcion.value)
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                _createTextVNode(" · Inscrito el " + _toDisplayString(fechaInscripcion.value), 1)
                              ], 64))
                            : _createCommentVNode("", true)
                        ])
                      ]),
                      (esListaConjunta.value)
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                            _hoisted_8,
                            _createVNode(_component_v_card, {
                              variant: "outlined",
                              class: "pa-3 mb-2"
                            }, {
                              default: _withCtx(() => [
                                _createElementVNode("div", _hoisted_9, [
                                  _createElementVNode("span", {
                                    class: _normalizeClass(`text-${_unref(estadoLista)(listaPareja.value?.listaData ? listaPareja.value.estadoLista : null).color}`)
                                  }, _toDisplayString(_unref(estadoLista)(listaPareja.value?.listaData ? listaPareja.value.estadoLista : null).texto), 3),
                                  (listaPareja.value?.ejercito)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_10, " · " + _toDisplayString(listaPareja.value.ejercito), 1))
                                    : _createCommentVNode("", true)
                                ]),
                                (listaPareja.value && (listaPareja.value.listaData || puedeCambiarListas.value))
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                                      (listaPareja.value.listaData)
                                        ? (_openBlock(), _createBlock(_component_v_btn, {
                                            key: 0,
                                            size: "small",
                                            variant: "tonal",
                                            class: "accion text-none",
                                            onClick: _cache[0] || (_cache[0] = ($event: any) => (alternarLista(listaPareja.value.idInscripcion)))
                                          }, {
                                            default: _withCtx(() => [
                                              _createTextVNode(_toDisplayString(listaVisible.value === listaPareja.value.idInscripcion ? "Ocultar lista" : "Ver lista"), 1)
                                            ]),
                                            _: 1
                                          }))
                                        : _createCommentVNode("", true),
                                      (puedeCambiarListas.value)
                                        ? (_openBlock(), _createBlock(_component_v_btn, {
                                            key: 1,
                                            size: "small",
                                            variant: "tonal",
                                            class: "accion text-none",
                                            onClick: _cache[1] || (_cache[1] = ($event: any) => (enviarCambiarLista(listaPareja.value)))
                                          }, {
                                            default: _withCtx(() => [
                                              _createTextVNode(_toDisplayString(listaPareja.value.listaData ? "Cambiar lista" : "Enviar lista"), 1)
                                            ]),
                                            _: 1
                                          }))
                                        : _createCommentVNode("", true)
                                    ]))
                                  : _createCommentVNode("", true),
                                _createVNode(_component_v_expand_transition, null, {
                                  default: _withCtx(() => [
                                    (listaPareja.value && listaVisible.value === listaPareja.value.idInscripcion)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                                          _createVNode(_component_v_img, {
                                            src: listaPareja.value.listaData,
                                            alt: "Lista de ejército",
                                            class: "rounded",
                                            contain: ""
                                          }, null, 8, ["src"])
                                        ]))
                                      : _createCommentVNode("", true)
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            })
                          ], 64))
                        : _createCommentVNode("", true),
                      _hoisted_13,
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(equipoConHuecos.value, (miembro, index) => {
                        return (_openBlock(), _createElementBlock(_Fragment, {
                          key: miembro?.idUsuario ?? `hueco-${index}`
                        }, [
                          miembro
                            ? (_openBlock(), _createBlock(_component_v_card, {
                                key: 0,
                                variant: "outlined",
                                class: "pa-3 mb-2"
                              }, {
                                default: _withCtx(() => [
                                  _createElementVNode("div", _hoisted_14, [
                                    _createTextVNode(_toDisplayString(miembro.nick) + " ", 1),
                                    (miembro.idUsuario === inscripcionData.value.idCapitan)
                                      ? (_openBlock(), _createElementBlock("span", _hoisted_15, " (capitán) "))
                                      : _createCommentVNode("", true)
                                  ]),
                                  (!esListaConjunta.value)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                                        _createElementVNode("span", {
                                          class: _normalizeClass(`text-${_unref(estadoLista)(miembro.listaData ? miembro.estadoLista : null).color}`)
                                        }, _toDisplayString(_unref(estadoLista)(miembro.listaData ? miembro.estadoLista : null).texto), 3),
                                        (miembro.ejercito)
                                          ? (_openBlock(), _createElementBlock("span", _hoisted_17, " · " + _toDisplayString(miembro.ejercito), 1))
                                          : _createCommentVNode("", true)
                                      ]))
                                    : _createCommentVNode("", true),
                                  (accionesDe(miembro).length > 0)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                                        (!esListaConjunta.value && miembro.listaData)
                                          ? (_openBlock(), _createBlock(_component_v_btn, {
                                              key: 0,
                                              size: "small",
                                              variant: "tonal",
                                              class: "accion text-none",
                                              onClick: ($event: any) => (alternarLista(miembro.idInscripcion))
                                            }, {
                                              default: _withCtx(() => [
                                                _createTextVNode(_toDisplayString(listaVisible.value === miembro.idInscripcion ? "Ocultar lista" : "Ver lista"), 1)
                                              ]),
                                              _: 2
                                            }, 1032, ["onClick"]))
                                          : _createCommentVNode("", true),
                                        (!esListaConjunta.value && puedeCambiarListas.value)
                                          ? (_openBlock(), _createBlock(_component_v_btn, {
                                              key: 1,
                                              size: "small",
                                              variant: "tonal",
                                              class: "accion text-none",
                                              onClick: ($event: any) => (enviarCambiarLista(miembro))
                                            }, {
                                              default: _withCtx(() => [
                                                _createTextVNode(_toDisplayString(miembro.listaData ? "Cambiar lista" : "Enviar lista"), 1)
                                              ]),
                                              _: 2
                                            }, 1032, ["onClick"]))
                                          : _createCommentVNode("", true),
                                        (puedeQuitar(miembro))
                                          ? (_openBlock(), _createBlock(_component_v_btn, {
                                              key: 2,
                                              size: "small",
                                              variant: "tonal",
                                              color: "error",
                                              class: "accion text-none",
                                              onClick: ($event: any) => (quitar.value = miembro)
                                            }, {
                                              default: _withCtx(() => [
                                                _createTextVNode(" Quitar ")
                                              ]),
                                              _: 2
                                            }, 1032, ["onClick"]))
                                          : _createCommentVNode("", true)
                                      ]))
                                    : _createCommentVNode("", true),
                                  _createVNode(_component_v_expand_transition, null, {
                                    default: _withCtx(() => [
                                      (!esListaConjunta.value && listaVisible.value === miembro.idInscripcion)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                                            _createVNode(_component_v_img, {
                                              src: miembro.listaData,
                                              alt: "Lista de ejército",
                                              class: "rounded",
                                              contain: ""
                                            }, null, 8, ["src"])
                                          ]))
                                        : _createCommentVNode("", true)
                                    ]),
                                    _: 2
                                  }, 1024)
                                ]),
                                _: 2
                              }, 1024))
                            : (_openBlock(), _createBlock(_component_v_card, {
                                key: 1,
                                variant: "outlined",
                                class: "pa-3 mb-2"
                              }, {
                                default: _withCtx(() => [
                                  _hoisted_20,
                                  (esCapitan.value && abierta.value)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                                        _createVNode(_component_v_btn, {
                                          size: "small",
                                          variant: "tonal",
                                          class: "accion text-none",
                                          onClick: abrirAnadirMiembro
                                        }, {
                                          default: _withCtx(() => [
                                            _createTextVNode(" Añadir jugador ")
                                          ]),
                                          _: 1
                                        })
                                      ]))
                                    : _createCommentVNode("", true)
                                ]),
                                _: 1
                              }))
                        ], 64))
                      }), 128)),
                      (props.idInscripcion)
                        ? (_openBlock(), _createBlock(InterruptorCompartirEmail, {
                            key: 1,
                            idInscripcion: props.idInscripcion,
                            valor: inscripcionData.value.compartirEmail,
                            class: "mt-3"
                          }, null, 8, ["idInscripcion", "valor"]))
                        : _createCommentVNode("", true),
                      (esCapitan.value && abierta.value)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                            _createVNode(_component_v_btn, {
                              variant: "text",
                              color: "error",
                              size: "small",
                              class: "text-none",
                              onClick: _cache[2] || (_cache[2] = ($event: any) => (eliminarInscripcion(inscripcionData.value.idEquipo)))
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(esParejas.value ? "Dar de baja a la pareja" : "Dar de baja al equipo"), 1)
                              ]),
                              _: 1
                            })
                          ]))
                        : _createCommentVNode("", true)
                    ], 64))
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_v_dialog, {
      "model-value": !!quitar.value,
      "max-width": "400",
      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (quitar.value = null))
    }, {
      default: _withCtx(() => [
        (quitar.value)
          ? (_openBlock(), _createBlock(_component_v_card, { key: 0 }, {
              default: _withCtx(() => [
                _createVNode(_component_v_card_title, { class: "text-wrap" }, {
                  default: _withCtx(() => [
                    _createTextVNode("¿Quitar a " + _toDisplayString(quitar.value.nick) + "?", 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_card_text, null, {
                  default: _withCtx(() => [
                    _createTextVNode(" Dejará de estar en " + _toDisplayString(esParejas.value ? "la pareja" : "el equipo") + " " + _toDisplayString(inscripcionData.value.nombreEquipo) + ". ", 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_card_actions, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_spacer),
                    _createVNode(_component_v_btn, {
                      variant: "text",
                      onClick: _cache[4] || (_cache[4] = ($event: any) => (quitar.value = null))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("Volver")
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_btn, {
                      color: "error",
                      variant: "flat",
                      loading: quitando.value,
                      onClick: confirmarQuitar
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("Quitar")
                      ]),
                      _: 1
                    }, 8, ["loading"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["model-value"]),
    _createVNode(ModalEnviarLista, {
      isVisible: showEnviarCambiarListaModal.value,
      "onUpdate:isVisible": _cache[6] || (_cache[6] = ($event: any) => ((showEnviarCambiarListaModal).value = $event)),
      idInscripcion: currentInscripcionId.value!,
      idUsuario: currentUsuarioId.value!,
      nick: currentNick.value!,
      hasLista: hasLista.value,
      onEnviarLista: guardarLista,
      onModificarLista: guardarLista
    }, null, 8, ["isVisible", "idInscripcion", "idUsuario", "nick", "hasLista"]),
    _createVNode(ModalAddMiembroEquipo, {
      isVisible: showModalRegistrarMiembroEquipo.value,
      idEquipo: inscripcionData.value.idEquipo,
      idTorneo: inscripcionData.value.idTorneo,
      jugadores: jugadoresSinEquipo.value,
      onClose: _cache[7] || (_cache[7] = ($event: any) => (showModalRegistrarMiembroEquipo.value = false)),
      onConfirm: alAnadirMiembro
    }, null, 8, ["isVisible", "idEquipo", "idTorneo", "jugadores"])
  ], 64))
}
}

})